import React, {useMemo} from "react";
import {BorderedBox} from "~/apps/core/ui/BorderedBox";


export type VehicleNumberProps = {
    number: string
};


export function humanizeVehicleNumber(value: string) {
    return value.replace(/[^a-zа-я0-9]/ig, '').replace(/(\d+)/g, ' $1 ').trim();
}


export const VehicleNumber = ({number}: VehicleNumberProps) => {
    const parts = useMemo(() => {
        const cleanValue = number && humanizeVehicleNumber(number).replace(/\s/g, "");
        const match = cleanValue.match(/^([a-zа-я]+\d+[a-zа-я]+)(\d+[a-zа-я]*)$/i);
        if (match) {
            return [match[1].replace(/(\d+)/, " $1 "), match[2].replace(/(\d+)/, "$1 ")];
        }
        return cleanValue ? [cleanValue.replace(/(\d+)/g, ' $1 ').trim()] : [];
    }, [number]);

    return (
        <BorderedBox>
            {parts.map((part, index) => (
                <span key={index}>{part}</span>
            ))}
        </BorderedBox>
    )
}